import { connect } from 'react-redux';
import { AdminIntegrations as AdminIntegrationsComponent } from './AdminIntegrationsComponent.jsx';

const mapStateToProperties = (state) => {
	const { currentUser } = state.user;
	return { currentUser };
};

export const AdminIntegrationsPage = connect(mapStateToProperties)(
	AdminIntegrationsComponent
);
